import styled from 'styled-components';

export const StyledCustomMenuItemContent = styled.div`
  padding: 0.8rem 1rem;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
`;
